import { Transition } from 'react-transition-group';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import './index.less';

const duration = 300;

const defaultFadeStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0
};

const transitionFadeStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
};

const defaultMoveStyle = {
  transition: `all ${duration}ms ease-in-out`,
  transform: `translate3d(0, 546px, 0)`,
  opacity: 0
};

const transitionMoveStyles = {
  entering: { transform: `translate3d(0, 0, 0)`, opacity: 1 },
  entered: { transform: `translate3d(0, 0, 0)`, opacity: 1 },
  exiting: { transform: `translate3d(0, 546px, 0)`, opacity: 0 },
  exited: { transform: `translate3d(0, 546px, 0)`, opacity: 0 }
};

interface Props {
  // @ts-ignore
  render: (show: boolean) => JSX.Element;
  onSure: (value: any) => void;
  onCancel: () => void;
  show: boolean;
}

export function WheelCom(props: Props) {
  const [display, setDisplay] = useState(false);
  const style = props.show || display ? {} : { display: 'none' };

  // @ts-ignore
  // @ts-ignore
  return (
    <Transition
      in={props.show}
      timeout={duration}
      appear={true}
      onExited={() => setDisplay(false)}
      onEnter={() => setDisplay(true)}
    >
      {state => (
        <div
          onClick={props.onCancel}
          className="wheel-pile"
          style={{
            ...defaultFadeStyle,
            ...transitionFadeStyles[state],
            ...style
          }}
        >
          <Transition in={props.show} timeout={duration} appear={true}>
            {state => (
              <div
                onClick={e => e.stopPropagation()}
                className="wheel-panel"
                style={{ ...defaultMoveStyle, ...transitionMoveStyles[state] }}
              >
                <div className="wheel-select">{props.render(props.show)}</div>
                <div className="reClose" onClick={props.onSure}>
                  取消
                </div>
              </div>
            )}
          </Transition>
        </div>
      )}
    </Transition>
  );
}

export default function(props: Props) {
  return ReactDOM.createPortal(<WheelCom {...props} />, document.body);
}
